import { formatZip, Heading, P, SimpleGrid, Stack, Text, useText } from "@sveabank/cc-common";
import type { ApplicationDetails } from "../../types/application";
import type { ContactInformationStepState } from "../../types/step";
import BorderDivider from "../border-divider";

type Props = {
	details: ApplicationDetails;
	companyInfo: ContactInformationStepState;
	applicantInfo: ContactInformationStepState;
};

const InformationSection = ({ details, companyInfo, applicantInfo }: Props) => {
	const [t, texts] = useText();
	return (
		<BorderDivider>
			<Stack gap={4}>
				<Heading.H4>{details.organization.orgName}</Heading.H4>
				<SimpleGrid cols={3}>
					<Stack>
						<P className="text-text-headline">
							<Text bold>{t(texts.contactInfo.companyInfo.visitingAddress)}</Text>
						</P>
						{details.organization.address && (
							<>
								<P>{details.organization.address.addressLine1}</P>
								<P>{details.organization.address.addressLine2}</P>
								<P>{`${formatZip(details.organization.address.zipCode)} ${
									details.organization.address?.city
								}`}</P>
							</>
						)}
						{companyInfo?.phone && (
							<P>{`${companyInfo.phone.countryCode} ${companyInfo.phone.number}`}</P>
						)}
						<P>{companyInfo?.email}</P>
					</Stack>
					<Stack>
						<P className="text-text-headline">
							<Text bold>{t(texts.contactInfo.companyInfo.postAddress)}</Text>
						</P>
						{details.applicant.address && (
							<>
								<P>{details.applicant.address.addressLine1}</P>
								<P>{details.applicant.address.addressLine2}</P>
								<P>{`${formatZip(details.applicant.address.zipCode)} ${
									details.applicant.address.city
								}`}</P>
							</>
						)}
					</Stack>
					<Stack>
						<P className="text-text-headline">
							<Text bold>
								{`${details.applicant.firstName || ""} ${details.applicant.lastName || ""}`}
							</Text>
						</P>
						{details.applicant.address && (
							<>
								<P>{details.applicant.address.addressLine1}</P>
								<P>{details.applicant.address.addressLine2}</P>
								<P>{`${formatZip(details.applicant.address.zipCode)} ${
									details.applicant.address.city
								}`}</P>
							</>
						)}
						{applicantInfo?.phone && (
							<P>{`${applicantInfo.phone.countryCode} ${applicantInfo.phone.number}`}</P>
						)}
						<P>{applicantInfo?.email}</P>
					</Stack>
				</SimpleGrid>
			</Stack>
		</BorderDivider>
	);
};

export default InformationSection;
